import { type IconProps } from './types'
/**
 * ![ZyxinxiTianchong](data:image/svg+xml;base64,PHN2ZyB0PSIxNzUwMDYxNzEyNzkwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExNzY0IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxwYXRoIGQ9Ik01MTIgOTYwQTQ0OCA0NDggMCAxIDAgNTEyIDY0YTQ0OCA0NDggMCAwIDAgMCA4OTZ6IG0wLTYxNC40QTQ0LjggNDQuOCAwIDEgMSA1MTIgMjU2YTQ0LjggNDQuOCAwIDAgMSAwIDg5LjZ6TTUxMiA3NjhhMzIgMzIgMCAwIDEtMzItMzJWNDQ4bDAuNTEyLTUuNzZBMzIgMzIgMCAwIDEgNTQ0IDQ0OHYyODhsLTAuNTEyIDUuNzZBMzIgMzIgMCAwIDEgNTEyIDc2OHoiIHAtaWQ9IjExNzY1Ij48L3BhdGg+PC9zdmc+)
 */
export const ZyxinxiTianchongIcon = ({ color = 'currentColor', size = 16, ...props }: IconProps) => {
  return (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...props}>
      <path
        d="M512 960A448 448 0 1 0 512 64a448 448 0 0 0 0 896z m0-614.4A44.8 44.8 0 1 1 512 256a44.8 44.8 0 0 1 0 89.6zM512 768a32 32 0 0 1-32-32V448l0.512-5.76A32 32 0 0 1 544 448v288l-0.512 5.76A32 32 0 0 1 512 768z"
        fill={color}
      ></path>
    </svg>
  )
}
